import { combineReducers } from "redux";
import { createItemReducer, createItemReducerParams } from "@mnjsplatform/data/lib/reducers/dataItemReducer";

export function orgChartReducer() {
    return combineReducers({
        AdmStruct_GetTreeForPO: createItemReducer('OrgChart', 'AdmStruct.GetTreeForPO', false),
        AdmStruct_GetPersonsForPO: createItemReducer('OrgChart', 'AdmStruct.GetPersonsForPO', false),
        AdmStruct_GetPersonsForPOParams: createItemReducerParams('OrgChart', 'AdmStruct.GetPersonsForPO'),
        PersonalCard_GetDataForOrgDiagFrame1PO: createItemReducerParams('OrgChart', 'PersonalCard.GetDataForOrgDiagFrame1PO'),
        PersonalCard_GetDataForOrgDiagFrame2PO: createItemReducerParams('OrgChart', 'PersonalCard.GetDataForOrgDiagFrame2PO'),
        PersonalCard_GetDataForOrgDiagFrame3PO: createItemReducerParams('OrgChart', 'PersonalCard.GetDataForOrgDiagFrame3PO'),
        AdmStruct_ListSubForPO: createItemReducerParams('OrgChart', 'AdmStruct.ListSubForPO'),
        AdmStructSetParamForPO_GetUserSelection: createItemReducer('OrgChart', 'AdmStructSetParamForPO.GetUserSelection', false),
        AdmStructSetParamForPO_GetUserDepartment: createItemReducer('OrgChart', 'AdmStructSetParamForPO.GetUserDepartment', false),
        AdmStruct_GetEmpListForPO: createItemReducer('OrgChart', 'AdmStruct.GetEmpListForPO', false),
        AdmStruct_GetEmpListForPOParams: createItemReducerParams('OrgChart', 'AdmStruct.GetEmpListForPO'),
    });
}